<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Dedication</h1>
</div>
</div>
<p style="margin-top:20%;text-align:center;font-size:1.2em;">
	For my friend Kathy Stohldrier who has expert taste and my friend Anthony Berin whose great smile should get him the job with the best tools when he grows up.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap138427.vue?3b5d2170